import classNames from 'classnames';
import { startCase, uniqueId } from 'lodash';

import IcomoonIcon from 'components/common/Icon/IcomoonIcon';
import { IconMap, RendererProps } from 'plugins/types';
import { ICON_COLORS } from 'styles/stylesProvider/themes';

import { TooltipPlacement, TruncateWithTooltip } from '../components';

import './EventTypeFieldRenderer.scss';

export enum EventTypeFieldRendererSize {
  MEDIUM = 16,
  LARGE = 24,
}

type EventTypeFieldRendererProps = RendererProps & {
  size?: EventTypeFieldRendererSize;
};

/**
 * Field renderer for EventType field, it is used both as a cell renderer and in LogInspector.
 */
export const EventTypeFieldRenderer = ({
  fieldId,
  row,
  schemaFields,
  value,
  size = EventTypeFieldRendererSize.MEDIUM,
}: EventTypeFieldRendererProps): JSX.Element => {
  const eventCategory = String(row['event.category']);
  const iconMap = schemaFields?.['event.category']?.icon as IconMap;
  const icon = iconMap?.[eventCategory];
  const displayValue = startCase(`${value ?? ''}`);
  const valueClassnames = classNames('EventTypeFieldRenderer__Value', {
    'EventTypeFieldRenderer__Value--Large': size === EventTypeFieldRendererSize.LARGE,
  });

  return (
    <div className="EventTypeFieldRenderer">
      {icon && (
        <span className="EventTypeFieldRenderer__Icon">
          <IcomoonIcon name={icon} size={size} color={ICON_COLORS.ICOMOON} />
        </span>
      )}
      <span className={valueClassnames} data-term-field={fieldId} data-term-value-type="string">
        <TruncateWithTooltip
          id={uniqueId(`EventTypeFieldRenderer-${value}-`)}
          text={displayValue}
          placement={TooltipPlacement.BOTTOM}
        />
      </span>
    </div>
  );
};
